<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="part" title="SECTION I: THE CHALLENGE: Carbon-Based, Analog, Feeling Humans in a Silicon-Infused, Digital, Data-Driven World">
<p class="secno" id="pa1"><a href="#/text/nav#rpa1"><span class="right_1" epub:type="pagebreak" id="page_1" title="1"><b>SECTION I</b></span></a></p>
<p class="sectitle"><a href="#/text/nav#rpa1">THE CHALLENGE:</a></p>
<p class="secsub"><a href="#/text/nav#rpa1"><i>Carbon-Based, Analog, Feeling Humans in a Silicon-Infused, Digital, Data-Driven World</i></a><span class="right_1" epub:type="pagebreak" id="page_2" title="2"></span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781400210664_Section1.vue?e90d4cc6